import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/site/Logo";

export const AdminSubPage = ({ testId, back = "/tigasatu/dashboard", backLabel = "Dashboard", title, subtitle, children }) => (
  <div className="grain min-h-screen bg-ink text-paper" data-testid={testId}>
    <header className="border-b border-white/[0.07]">
      <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-5">
        <Logo />
        <a href={back} data-testid={`${testId}-back`} className="flex items-center gap-1.5 text-sm text-zinc-300 hover:text-paper"><ArrowLeft className="h-4 w-4" /> {backLabel}</a>
      </div>
    </header>
    <main className="mx-auto max-w-5xl px-5 py-12">
      <h1 className="font-display text-3xl font-bold md:text-4xl">{title}</h1>
      {subtitle ? <p className="mt-2 text-zinc-400">{subtitle}</p> : null}
      <section className="mt-8 rounded-3xl bg-surface p-5 ring-1 ring-white/[0.07] md:p-8">{children}</section>
    </main>
  </div>
);
